module.exports = __webpack_public_path__ + "img/momo_index_bg_bottom.c8f4a627.png";